<template>
  <div
    class="p-menus-no-detail__block"
    v-if="
      Object.keys(serviceArea).length > 0 &&
      serviceArea.areaDiv
    "
  >
    <h3 class="p-menus-no-detail__block__title c-title2">
      サービス対象エリア
    </h3>
    <div class="p-menu-service-area-list">
      <p class="c-label c-label--common">{{ serviceArea.areaDivNm }}</p>
      <ul
        class="p-menu-service-area-list__items"
        v-if="
          serviceArea.serviceTrgetAreas &&
          serviceArea.serviceTrgetAreas.length > 0
        "
      >
        <li
          class="p-menu-service-area-list__item"
          v-for="item in serviceAreaList"
          :key="item.prefId"
        >
          <div class="p-menu-service-area-list__accordion" @click="open(item)">
            <h4 class="p-menu-service-area-list__accordion--title">
              {{ item.prefNm }}
            </h4>
            <transition name="rotate" mode="out-in">
              <Icon
                v-if="!item.isOpen"
                key="rotate1"
                name="arrow_pull_down"
                width="24px"
                height="24px"
                :color="$colors.brand.red"
              />
              <Icon
                v-else
                key="rotate2"
                name="arrow_pull_up"
                width="24px"
                height="24px"
                :color="$colors.brand.red"
              />
            </transition>
          </div>
          <transition name="open">
            <p v-if="item.isOpen" class="p-menu-service-area-list__item--area">
              {{ item.municipalities }}
            </p>
          </transition>
        </li>
      </ul>
    </div>
    <div class="p-menu-service-area-list area-note" v-if="serviceArea.areaNote">
      <p class="c-label c-label--note">{{ serviceArea.areaNote }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    serviceArea: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    serviceAreaList() {
      if (!this.serviceArea || !this.serviceArea.serviceTrgetAreas) return [];
      return this.serviceArea.serviceTrgetAreas;
    },
  },
  methods: {
    open(item) {
      this.$set(item, 'isOpen', !item.isOpen);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
